/* eslint-disable react/display-name */
import React from 'react'

import { useForm } from 'react-hook-form'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import styled from 'styled-components'

import { submitEventForm } from '../../_actions'
import { phonenumber, email } from '../../_helpers'
import {
    Container,
    devices,
    colors,
    Button,
    UpperHeader,
    Input,
    Form,
    FormError,
    MultiChoiceInput,
    RadioInput,
    BaseLabel,
    Header,
} from '../Common'

const TextInput = React.forwardRef(({ label, type, name, errors, debug }, ref) => (
    <InputWrap>
        {errors[name] && <FormError>{errors[name].message}</FormError>}
        <Input required color={colors.inputBlack} type={type || 'text'} aria-label={label} placeholder={label} name={name} ref={ref} />
    </InputWrap>
))

const Choice = React.forwardRef(({ id, value }, ref) => (
    <BaseLabel>
        {value}
        <input type='checkbox' name='interest' value={value} id={id} ref={ref} />
        <MultiChoiceInput />
    </BaseLabel>
))

const RadioButton = React.forwardRef(({ value }, ref) => (
    <BaseLabel>
        {value}
        <input type='radio' name='event_type' value={value} ref={ref} />
        <RadioInput />
    </BaseLabel>
))

const EventForm = () => {
    const { register, handleSubmit, errors } = useForm({ mode: 'onBlur' })
    const { eventMessage, eventError } = useSelector(state => state.content, shallowEqual)
    const dispatch = useDispatch()
    const onSubmit = data => dispatch(submitEventForm(data))
    // const onSubmit = data => console.warn(data)
    const registerOptions = { required: 'This field is required' }

    return (
        <FormContainer>
            <UpperHeader marginbottom={30}>Event Form</UpperHeader>
            <Form onSubmit={handleSubmit(onSubmit)} style={{ width: '50%' }}>
                <TextInput debug='test@test.com' label='Email' type='email' name='email' errors={errors} ref={register({ ...registerOptions, validate: val => email(val) })} />
                <TextInput debug='test' label='Full Name' name='full_name' errors={errors} ref={register(registerOptions)} />
                <TextInput debug='test' label='Company' name='company' errors={errors} ref={register} />
                <TextInput debug='9999999999' label='Phone Number' type='tel' name='phone_number' errors={errors} ref={register({ ...registerOptions, validate: val => phonenumber(val) })} />
                <TextInput debug='test' label='Event Date' name='event_date' errors={errors} ref={register(registerOptions)} />
                <TextInput debug='test' label='Event Location' name='event_location' errors={errors} ref={register(registerOptions)} />
                <TextInput debug='test' label='Event Time(s)' name='event_time' errors={errors} ref={register(registerOptions)} />
                <TextInput debug='test' label='Event Theme' name='event_theme' errors={errors} ref={register(registerOptions)} />
                <TextInput debug='5' type="number" label='Number of Guests' name='number_of_guests' errors={errors} ref={register(registerOptions)} />
                <TextInput debug='50000' type="number" label='Budget' name='budget' errors={errors} ref={register(registerOptions)} />
                <InputWrap>
                    <Header fontSize={27} marginbottom={20} margintop={20}>Type of Event</Header>
                    <RadioButton value='Corporate' ref={register(registerOptions)} />
                    <RadioButton value='Gala' ref={register(registerOptions)} />
                    <RadioButton value='Bar Mitzvah' ref={register(registerOptions)} />
                    <RadioButton value='Personal Event' ref={register(registerOptions)} />
                    <RadioButton value='School Related' ref={register(registerOptions)} />
                    <BaseLabel>
                        Other: &nbsp;
                        <input type='radio' name='event_type' value='Other (see below)' ref={register(registerOptions)} />
                        <RadioInput />
                        <OtherInput color={colors.inputBlack} type='text' placeholder='Specify' name='other_event' aria-label='specify' ref={register} />
                    </BaseLabel>
                </InputWrap>
                <InputWrap>
                    <Header fontSize={27}>Interest</Header>
                    <UpperHeader fontSize={8} marginbottom={20}>— Check all that apply</UpperHeader>
                    <Choice id='decor' value='Decor' ref={register} />
                    <Choice id='linens' value='Linens' ref={register} />
                    <Choice id='centerpieces' value='Centerpieces / Florals' ref={register} />
                </InputWrap>
                <Button type='submit' onClick={handleSubmit(onSubmit)}>SUBMIT</Button>
                {eventMessage || eventError ?
                    <InputWrap style={{marginTop: '20px'}}>
                        {eventMessage || eventError}
                    </InputWrap> : ''
                }
            </Form>
        </FormContainer>
    )
}

const FormContainer = styled(Container)`
    background: ${colors.black};
    padding: 50px;
`

export const InputWrap = styled.div`
    margin-bottom: 5px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    color: ${colors.white};
`

const OtherInput = styled(Input)`
    padding: 2px;
    font-size: 16px;
`

export default EventForm